"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Qdp = function Qdp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.803 7.863L9.5 25.339v44.158l37.67 18.648 37.324-16.073-.123-46.724L46.803 7.863zm43.49 69.333L47.815 95.489a2 2 0 0 1-1.678-.045L3.613 74.394A2 2 0 0 1 2.5 72.6V22.16a2 2 0 0 1 1.152-1.811L45.948.533A2 2 0 0 1 47.64.531l42.567 19.812a2 2 0 0 1 1.156 1.808l.14 53.203a2 2 0 0 1-1.21 1.842z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.581 19.877a3.5 3.5 0 0 0-3.162 6.246l39.5 20a3.5 3.5 0 0 0 3.162 0l39.5-20a3.5 3.5 0 0 0-3.162-6.246L46.5 39.077l-37.919-19.2z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.5 91V42h-7v49z"
  }))));
};
var _default = exports.default = Qdp;